import { currentPage } from '../common/layout';
import { getStroeerGalleryBanners } from '../common/utils/adv-stroeer-mobile-gallery-loader';
import 'jquery-mousewheel';
import '../common/jquery-snap-scroll';
import '../common/lightgallery/jquery-lightgallery';
import '../common/lightgallery/jquery-lightgallery-aside';
import '../common/lightgallery/jquery-lightgallery-additional';
import '../common/lightgallery/jquery-lightgallery-topside';
import '../common/lightgallery/jquery-lightgallery-custom-content';
import '../common/msnt/msnt-lightslider.js';
// import '../common/lazyload.picture';
import { getCookie } from '../common/utils/fn';
import { msntPhotoThumbGallery } from '../common/msnt/msnt-loader';
import { updateShortDescriptionBox } from '../common/short-description';

currentPage.pageInit = ($page, pageData, pageId) => {
  var $dataEdtn = $('body').data('edtn');
  msntPhotoThumbGallery().then((api) => {
    api.msntPhotoThumbGallery();
  });

  $('.msnt-items-slider').snapScrollControl();

  var cpAuthhint = document.cookie.includes('_cpauthhint=1');
  if ($dataEdtn == 'de' || $dataEdtn == 'ev_de' && !cpAuthhint) {
    getStroeerGalleryBanners().then((api) => {
      api.initDeMobileGalleryBanners();
    });
  }

  if ($dataEdtn == 'us' || $dataEdtn == 'ra_us' || $dataEdtn == 'ev_us') {
    const headerRequest = new Request(document.location);
    fetch(headerRequest).then((response) => {
      const headerTitle = "Geoip-Country";
      if(response.headers.has(headerTitle)){
        var title = response.headers.get(headerTitle);
        gtmDataLayer.push({
          event: 'geoIpIsPresent',
          'userGeoIp': title
        });
      }
    });
  }

  let galleryButton = document.querySelector('.share-button-gallery');
    if (galleryButton) {
      galleryButton.addEventListener('click', function(event){
        event.preventDefault();
        event.stopPropagation();
      });
    }

  // console.log(document.getElementsByTagName('h1')[0].textContent, document.location.href);

  const shareData = {
    title: document.getElementsByTagName('h1')[0].textContent,
    url: document.location.href,
  };
  
  let shareButton = document.getElementsByClassName('m1-article-meta_share')[0];
  // console.log(shareButton, window.device.type);
  if (shareButton && window.device.type !== 'desktop') {
    shareButton.addEventListener("click", async () => {
      // console.log('clicked');
      try {
        await navigator.share(shareData);
      } catch (err) {
        console.log(err);
      }
    });
  }

  updateShortDescriptionBox();
  window.addEventListener('resize', updateShortDescriptionBox);
};
